export const ROUTE_HOME_PAGE = "/";
export const ROUTE_ABOUT_US = "/about_us";
export const ROUTE_CONTACT = "/contact";
export const ROUTE_POLICIES = "/policies";
export const ROUTE_PRIVACY = "/privacy";
export const ROUTE_FAQ = "/FAQ";
//search
export const ROUTE_SEARCH = "/search";
//sims
export const ROUTE_SIMS = "/sims";
export const ROUTE_SIM = "/sim/";
export const ROUTE_SIM_ID = "/sim/:id";
export const ROUTE_SIM_DETAIL = "/sim-detail/";
export const ROUTE_SIM_DETAIL_ID = "/sim-detail/:id";
export const ROUTE_SIM_REPORT_ACTIVITY = "/sim-activity-report/";
export const ROUTE_SIM_REPORT_ACTIVITY_ID = "/sim-activity-report/:id";
//login
export const ROUTE_LOGIN_BY_TOKEN = "/login-by-token";
export const ROUTE_AUTHENTICATION = "/authentication";
export const ROUTE_FORGET_PASSWORD = "/forget-password";
//purchase
export const ROUTE_PURCHASE = "/purchase";
export const ROUTE_COMPANY_DETAIL = "/company-detail";
export const ROUTE_PAYMENT = "/payment";
export const ROUTE_CART = "/cart";
export const ROUTE_GROUP_PURCHASE = "/group-purchase";
export const ROUTE_PURCHASE_SUBSCRIPTION_CODE = "/purchase-subscription-code";
export const ROUTE_PERSONAL_PURCHASE_PAGE = "/personal-purchase";

//profile
export const ROUTE_MY_POINT = "my-point";
export const ROUTE_MY_WALLET = "my-wallet";
export const ROUTE_MY_WALLET_WITHDRAW = "my-wallet-withdraw";
export const ROUTE_MY_WALLET_DEPOSIT = "my-wallet-deposit";
export const ROUTE_MY_PROFILE = "my-profile";
export const ROUTE_MY_LIST = "my-list";
export const ROUTE_MY_EXPERIMENT = "my-experiment";
export const ROUTE_MY_COMMENT_LIST = "my-comment-list";
export const ROUTE_MY_REPORT_LIST = "my-report-list";
export const ROUTE_MY_MESSAGE_LIST = "my-message-list";
export const ROUTE_MY_FINANCIAL_LIST = "my-financial-list";
export const ROUTE_FINANCIAL_DETAIL = "financial-detail/";
export const ROUTE_FINANCIAL_DETAIL_ID = "financial-detail/:id";
export const ROUTE_TOKEN_DETAIL_ID = "token-detail/:id";
export const ROUTE_TOKEN_DETAIL = "token-detail/";
export const ROUTE_REFERRAL = "referral";
export const ROUTE_REFERRAL_DETAIL = "referral-detail";
export const ROUTE_REFERRAL_DETAIL_WITHDRAW = "referral-detail-withdraw";
export const ROUTE_CHANGE_USER_INF = "change-user-inf";
export const ROUTE_CHANGE_USER_PASS = "change-user-pass";
export const ROUTE_FINANCIAL_FACTOR_DETAIL = "factor-detail";
export const ROUTE_FINANCIAL_FACTOR_DETAIL_ID = "factor-detail/:id";

// //student
export const ROUTE_STUDENT = "/student";
// //teacher
export const ROUTE_TEACHER = "/teacher";

export const ROUTE_ERROR_PAGE = "*";
export const ROUTE_BLOG = "https://www.azeto.ir/blog";
